/*
 * Module for handling the list of URLs for a piece of
 * mapped content
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/upload/contentUploadModel",
  "modules/contentsSplit/content/contentUrls/contentUrlsView",
], function (Marionette, Messenger, ContentUploadModel, ContentUrlsView) {
  var ContentUrlsController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "contentUrls";
      this.region = options.region;
      this.selectedSearchLocale = options.selectedSearchLocale;
      this._setUpVents();
    },
    show: function (urlsCollection) {
      this.urls = urlsCollection;
      //get default response language:
      var defaultLang = Messenger.reqres.request("default:response:language");
      //get touchpoints list
      this.touchpoints = Messenger.reqres.request("kb:touchpoints");
      // If the locale selected on the search page was "All", then set it to the default instead
      if (this.selectedSearchLocale === 0) {
        this.selectedSearchLocale = defaultLang;
      }
      //prepare the urls once the list is loaded
      this.urls.onSynced(function () {
        this.prepareUrls(this.selectedSearchLocale);
      }, this);

      this.view = new ContentUrlsView.contentUrlsView({
        language: this.selectedSearchLocale,
        collection: urlsCollection,
      });

      this.view.on("itemview:click:preview", function (itemView) {
        Messenger.vent.trigger("show:preview", itemView.model.get("url"));
        //show modification bar
        Messenger.vent.trigger("show:modification:information", itemView.model);
      });

      //Let's also show the preview when the content awareness icon is clicked
      this.view.on("itemview:click:missing", function (itemView) {
        Messenger.vent.trigger("show:preview", itemView.model.get("url"));
        //show modification bar
        Messenger.vent.trigger("show:modification:information", itemView.model);
      });
      this.view.on("itemview:click:modified", function (itemView) {
        Messenger.vent.trigger("show:preview", itemView.model.get("url"));
        //show modification bar
        Messenger.vent.trigger("show:modification:information", itemView.model);
      });

      this.view.on("itemview:click:ignored", function (itemView) {
        Messenger.vent.trigger("show:preview", itemView.model.get("url"));
        //show modification bar
        Messenger.vent.trigger("show:modification:information", itemView.model);
      });

      this.showRegion(this.view, { loading: true });
    },
    prepareUrls: function (language) {
      //cannot prepare the urls until the touchpoint list is loaded too
      this.touchpoints.onSynced(() => this._prepareUrls(language));
    },
    _prepareUrls: function (language) {
      //for each touchpoint, find the url with that touchpoint and lanaguage Id.
      //If it doesn't exist, create it.  Add the name of the touchpoint as a variable to
      //the URL.
      this.touchpoints.each(function (touchpoint) {
        var touchpointId = touchpoint.get("touchPointId");
        var matchingURL = this.urls.findWhere({ touchpointId: touchpointId, languageId: language });
        if (!matchingURL) {
          //create a new url since it doesn't exist
          matchingURL = this.urls.addNewUrl(touchpointId, language);
        }
        matchingURL.touchpoint = touchpoint.get("touchPoint");
      }, this);
      //sort the urls by touchpoint name
      this.urls.sort();
      if (this.view) {
        this.view.render();
      }
    },
    _saveFileUpload: function (fileName, fileSize, isUploaded, uploadId, urlPath, urlModel) {
      urlModel.set("isUploaded", isUploaded);
      urlModel.set("uploadId", uploadId);
      urlModel.set("fileName", fileName);
      urlModel.set("byteSize", fileSize);
      urlModel.set("url", urlPath);

      //this.view.render();
      /**
          Messenger.save(function(success){
            if (success) {
              console.log("content saved!");
            }
            else {
              console.log("save failed!");
            }
          }, this);
          **/
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "content:language:changed",
        function (languageId) {
          this.view.language = languageId;
          this.prepareUrls(languageId); //make sure all the urls for this language exist
        },
        this,
      );

      Messenger.vent.on(
        "content:upload:changed",
        function (isSuccess, fileName, fileSize, isUploaded, uploadId, urlPath, urlModel) {
          if (this.view && isSuccess) {
            this._saveFileUpload(fileName, fileSize, isUploaded, uploadId, urlPath, urlModel);
          }
        },
        this,
      );
    },
  });

  return ContentUrlsController;
});
